import { State } from ".";
import { DirtyDates } from "./sync";

export const getLastSyncTime = (state: State): string =>
    state.data.sync.lastSyncTime;

export const getDirtyDates = (state: State): DirtyDates =>
    state.data.sync.dirtyDates;

export const getHasDirtyDates = (state: State): boolean =>
    Object.keys(state.data.sync.dirtyDates).length > 0;
